<div
  *transloco="let t; read: 'configuration-routes.edit.configurations'"
  class="included-configurations__wrapper"
>
  @if (isLoading || isSaving) {
    <div class="xi-loader-container__inline-overlay xi-loader-container__inline-overlay--blur">
      <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
    </div>
  }

  <div class="included-configurations__search">
    <xi-search-box
      [placeholder]="t('filter')"
      [stretch]="true"
      [hasOutline]="false"
      (keyup)="search$.next($event.target.value)"
      (onCancelClick)="search$.next('')"
    ></xi-search-box>
  </div>

  <app-configuration-selector-list
    [configurations]="filteredAvailableConfigurations"
    [headerText]="t('available')"
    [buttonText]="t('add')"
    [isLeftSide]="true"
    (entryAction)="onConfigurationAdded($event)"
  >
  </app-configuration-selector-list>

  <app-configuration-selector-list
    [configurations]="includedConfigurations"
    [headerText]="t('selected')"
    [buttonText]="t('remove')"
    (entryAction)="onConfigurationRemoved($event)"
  >
  </app-configuration-selector-list>
</div>
